import './index.scss';

import Main from '../main';

const App = () => {
  return (
    <div className='app-main'>
      <Main />
    </div>
  );
};

export default App;